"use strict";
import { validateGasFeeResult } from "uniswap/src/features/gas/types";
import { isBridge, isClassic, isUniswapX, isWrap } from "uniswap/src/features/transactions/swap/utils/routing";
import { isInterface } from "utilities/src/platform";
export function isValidSwapTxContext(swapTxContext) {
  return validateSwapTxContext(swapTxContext) !== void 0;
}
export var PermitMethod = /* @__PURE__ */ ((PermitMethod2) => {
  PermitMethod2["Transaction"] = "Transaction";
  PermitMethod2["TypedData"] = "TypedData";
  return PermitMethod2;
})(PermitMethod || {});
function validateSwapTxContext(swapTxContext) {
  if (!isSwapTx(swapTxContext)) {
    return void 0;
  }
  const gasFee = validateGasFeeResult(swapTxContext.gasFee);
  if (!gasFee) {
    return void 0;
  }
  if (swapTxContext.trade) {
    if (isClassic(swapTxContext)) {
      const { trade, unsigned, permit, txRequests, includesDelegation } = swapTxContext;
      if (unsigned) {
        if (!isInterface || !permit || permit.method !== "TypedData" /* TypedData */) {
          return void 0;
        }
        return { ...swapTxContext, trade, gasFee, unsigned, txRequests: void 0, permit, includesDelegation: includesDelegation ?? false };
      } else if (txRequests) {
        return { ...swapTxContext, trade, gasFee, unsigned, txRequests, permit: void 0, includesDelegation: includesDelegation ?? false };
      }
    } else if (isBridge(swapTxContext)) {
      const { trade, txRequests, includesDelegation } = swapTxContext;
      if (txRequests) {
        return { ...swapTxContext, trade, gasFee, txRequests, includesDelegation: includesDelegation ?? false };
      }
    } else if (isUniswapX(swapTxContext) && swapTxContext.permit) {
      const { trade, permit } = swapTxContext;
      return { ...swapTxContext, trade, gasFee, permit, includesDelegation: false };
    } else if (isWrap(swapTxContext)) {
      const { trade, txRequests } = swapTxContext;
      if (txRequests) {
        return { ...swapTxContext, trade, gasFee, txRequests, includesDelegation: false };
      }
    }
  }
  return void 0;
}
function isSwapTx(swapTxContext) {
  return typeof swapTxContext === "object" && swapTxContext !== null && "trade" in swapTxContext && "routing" in swapTxContext;
}
